export default "__VITE_ASSET__GSXe3h8s__"